export const advancedToolsEs = {
  advancedTools: {
    title: "Herramientas Agrícolas Avanzadas",
    subtitle: "Funciones profesionales con datos reales",
    noParcels: "Sin Parcelas",
    noParcelsDesc: "Añade una parcela primero para usar las herramientas avanzadas",
    selectParcel: "Seleccionar parcela",
    scouting: "Scouting",
    gdd: "GDD",
    harvest: "Cosecha",
    vraExport: "Exportar VRA",
    timelapse: "Time-Lapse",
    rotation: "Rotación",
    tasks: "Tareas",
    carbon: "Carbono",
    ndviZones: "Zonas NDVI",
    createScoutingReport: "Crear Informe de Scouting",
    noParcelSelected: "Sin parcela seleccionada",
    harvestEstimator: "Estimador de Valor de Cosecha Mejorado",
    selectParcelOptional: "Seleccionar Parcela (Opcional)",
    chooseParcel: "Elegir parcela existente...",
    cropType: "Tipo de Cultivo",
    areaHectares: "Superficie (Hectáreas)",
    enterArea: "Introduce la superficie en hectáreas",
    yieldFactor: "Factor de Rendimiento Esperado",
    poorSeason: "Temporada Mala (60%)",
    belowAverage: "Por Debajo de la Media (80%)",
    averageSeason: "Temporada Media (100%)",
    goodSeason: "Buena Temporada (120%)",
    excellentSeason: "Temporada Excelente (140%)",
    expectedQuality: "Calidad Esperada",
    basicQuality: "Calidad Básica (80%)",
    standardQuality: "Calidad Estándar (100%)",
    premiumQuality: "Calidad Premium (120%)",
    calculating: "Calculando...",
    calculateEstimation: "Calcular Estimación",
    yearOverYear: "Análisis Año contra Año",
    previousYear: "Año Anterior",
    growth: "Crecimiento",
    marketTrend: "Tendencia de Mercado",
    rising: "Subiendo",
    falling: "Bajando",
    stable: "Estable",
    totalEstimatedValue: "Valor Total Estimado",
    valuePerHectare: "Valor por Hectárea",
    estimatedCosts: "Costes Estimados",
    estimatedProfit: "Beneficio Estimado",
    profitMargin: "Margen de Beneficio",
    yieldEstimate: "Estimación de Rendimiento",
    totalYield: "Rendimiento Total",
    yieldPerHa: "Rendimiento por Ha",
    ndviAdjustment: "Ajuste NDVI",
    qualityMultiplier: "Multiplicador de Calidad",
    seasonalForecast: "Previsión Estacional",
    probability: "probabilidad",
    exportComplete: "Exportación Completa",
    exportedSuccess: "Estimación de cosecha exportada correctamente",
    noDataExport: "Sin Datos",
    noEstimationExport: "Sin datos de estimación para exportar",
    errorCalculating: "Error al calcular la estimación de valor de cosecha",
    enterValidArea: "Introduce una superficie válida en hectáreas",
    optimalHarvest: "Calculadora de Cosecha Óptima",
    calculateOptimalHarvest: "Calcular Cosecha Óptima",
    optimalDate: "Fecha Óptima",
    maturity: "Madurez",
    netValue: "Valor Neto",
    daysFromNow: "Días desde hoy",
    cropRotation: "Planificador de Rotación de Cultivos",
    currentCrop: "Cultivo Actual",
    soilHealthScore: "Puntuación de Salud del Suelo",
    recommendedRotation: "Rotación Recomendada (Próximo Año)",
    nBalance: "Balance de N",
    riskReduction: "Reducción de Riesgo",
    automatedTasks: "Recomendaciones Automatizadas de Tareas",
    noRecommendations: "Sin recomendaciones aún",
    taskDate: "Fecha",
    confidence: "Confianza",
    accept: "Aceptar",
    reject: "Rechazar",
    taskAccepted: "Tarea aceptada",
    taskRejected: "Tarea rechazada",
    carbonCalculator: "Calculadora de Huella de Carbono",
    howToUse: "Cómo usar esta calculadora:",
    step1Title: "PASO 1: Registra tus actividades agrícolas",
    step1Desc: "Ve a \"Cuaderno de Campo\" y registra todas las actividades del período que quieras analizar:",
    fertilizerApps: "Aplicaciones de fertilizante (especifica cantidad en kg)",
    fuelUsage: "Uso de combustible (diésel en litros)",
    pesticideApps: "Aplicaciones de pesticidas/herbicidas (kg)",
    electricityConsumption: "Consumo de electricidad (kWh) para riego",
    step2Title: "PASO 2: Registros disponibles de índices Sentinel-2",
    step2Desc: "El sistema puede usar registros disponibles de índices Sentinel-2 cuando existen.",
    step3Title: "PASO 3: Selecciona fechas y calcula",
    step3Desc: "Elige el rango de fechas abajo y pulsa \"Calcular Huella de Carbono\".",
    scientificMethodology: "Metodología: emisiones basadas en actividades usando factores de emisión estándar",
    emissions: "Emisiones",
    sequestration: "Secuestro",
    netBalance: "Balance Neto",
    startDate: "Fecha Inicio",
    endDate: "Fecha Fin",
    calculateCarbon: "Calcular Huella de Carbono",
    emissionBreakdown: "Desglose de Emisiones",
    fertilizer: "Fertilizante",
    pesticides: "Pesticidas",
    diesel: "Diésel",
    electricity: "Electricidad",
    globalBiomass: "Stock de Carbono de Biomasa Global",
    totalCarbonStock: "Stock Total de Carbono",
    aboveGround: "Sobre el Suelo",
    soilOrganicCarbon: "Carbono Orgánico del Suelo",
    co2Equivalent: "Equivalente CO₂",
    climateZone: "Zona Climática",
    selectDates: "Por favor selecciona las fechas de inicio y fin",
    noActivities: "Sin actividades agrícolas registradas en este período. Registra actividades en \"Cuaderno de Campo\" primero.",
    noNdviWarning: "Advertencia: Sin datos NDVI disponibles. Solo se calcularán emisiones, no secuestro de carbono.",
    carbonSuccess: "Huella de carbono calculada correctamente",
    loginRequired: "Debes iniciar sesión para calcular la huella de carbono",
    timelapseTitle: "Generador de Time-Lapse NDVI",
    indexType: "Tipo de Índice",
    captureNow: "Capturar Ahora",
    capturing: "Capturando...",
    generateFrames: "Generar Frames",
    generating: "Generando...",
    framesReady: "frames listos",
    downloadAllFrames: "Descargar Todos los Frames",
    ffmpegHint: "Usa ffmpeg localmente para crear el video:",
    captureStarted: "Captura iniciada",
    parcelsProcessed: "parcelas procesadas",
    noFramesReceived: "No se recibieron frames",
    selectStartEnd: "Por favor selecciona fecha de inicio y fin",
    downloadingFrames: "Descargando todos los frames",
    framesReadyDownload: "frames listos para descargar",
    tasksExplanation: "Las tareas se generan a partir de alertas de parcela, recomendaciones de riego, riesgo de sequía, reportes de scouting, recomendaciones de fertilización e incidencias abiertas.",
    tasksAutomaticInactive: "La generación automática de tareas aún no está activa. Las recomendaciones aparecerán aquí cuando se genere una alerta, plan de riego, señal de sequía, reporte de scouting o plan de fertilización para esta parcela.",
    carbonDataSourceNote: "Los indicadores de carbono se estiman a partir de datos disponibles de parcela, cultivo y manejo. Las capas satelitales de biomasa o carbono requieren una fuente de datos activa configurada.",
    ruleBasedRecommendation: "Recomendación basada en reglas",
    noRealVraZones: "No hay zonas VRA reales disponibles para esta parcela. Ejecuta primero el Optimizador de Nitrógeno.",
    biomassDataLimited: "Capas satelitales de biomasa no disponibles (fuente de datos no configurada).",
    biomassRequiresConfig: "Requiere configuración",
    carbonSectionA: "Huella de carbono basada en actividades",
    carbonSectionADesc: "Estimado a partir de actividades agrícolas y factores de emisión estándar.",
    carbonSectionB: "Indicador satelital de biomasa vegetal",
    carbonSectionBDesc: "Indicador satelital de biomasa vegetal basado en índices Sentinel-2 disponibles. No es una estimación verificada de stock de carbono.",
    carbonSectionBEmpty: "No hay observaciones de índices de vegetación Sentinel-2 para el rango de fechas seleccionado.",
    carbonSectionBVigorLow: "Vigor vegetativo bajo",
    carbonSectionBVigorModerate: "Vigor vegetativo moderado",
    carbonSectionBVigorHigh: "Vigor vegetativo alto",
    carbonSectionBObservations: "observaciones",
    carbonSectionC: "Stock de carbono verificado / Créditos de carbono",
    carbonSectionCDesc: "El stock de carbono verificado y los créditos de carbono requieren metodología validada, calibración de campo y verificación externa. Esto aún no está activo.",
    statusActive: "Activo",
    statusDataDependent: "Depende de datos",
    statusNotActive: "No activo",
    statusRequiresValidation: "Requiere validación",
    ruleBasedBadge: "Basado en reglas",
    tasksActiveExplanation: "Las tareas se generan a partir de eventos reales de la parcela, como recomendaciones de riego, riesgo de plagas/enfermedades, reportes de scouting, recomendaciones de nitrógeno y zonas de bajo vigor.",
    tasksEmptyActive: "Aún no hay recomendaciones de tareas. Las tareas aparecerán cuando se detecten eventos relevantes en la parcela.",
    tasksEmptyGuidance: "Para generar tareas, crea un reporte de scouting, guarda una recomendación de riego, ejecuta el Optimizador de Nitrógeno o analiza el riesgo de plagas/enfermedades.",
    generateTasksNow: "Generar tareas ahora",
    generatingTasks: "Generando...",
    tasksGenerated: "Tareas generadas",
    taskTypeLabels: {
      review_irrigation: "Revisar plan de riego",
      scout_pest_disease: "Realizar scouting por riesgo de plagas o enfermedades",
      followup_scouting: "Dar seguimiento a hallazgo de scouting",
      review_vra_nitrogen: "Revisar aplicación variable de nitrógeno",
      inspect_low_vigor: "Inspeccionar zona de bajo vigor"
    }
  },
  fieldNotebook: {
    title: "Cuaderno de Campo Digital",
    parcel: "Parcela",
    newActivity: "Nueva Actividad",
    registerActivity: "Registrar Actividad Agrícola",
    registerDesc: "Los datos se validarán automáticamente con información satelital",
    date: "Fecha",
    activityType: "Tipo de Actividad",
    planting: "Siembra",
    irrigation: "Riego",
    fertilization: "Fertilización",
    pestControl: "Control de Plagas",
    pruning: "Poda",
    harvestActivity: "Cosecha",
    soilAnalysis: "Análisis de Suelo",
    other: "Otro",
    productsUsed: "Productos Utilizados",
    productsPlaceholder: "Ej: Fertilizante NPK 15-15-15",
    quantity: "Cantidad",
    unit: "Unidad",
    unitPlaceholder: "kg, L, ha",
    cost: "Coste (€)",
    notes: "Notas",
    notesPlaceholder: "Observaciones, condiciones climáticas, etc.",
    register: "Registrar Actividad",
    registering: "Registrando...",
    cancel: "Cancelar",
    totalActivities: "Total Actividades",
    totalCost: "Coste Total",
    validated: "Validadas",
    noActivities: "Sin actividades registradas",
    startRegistering: "Comienza registrando tu primera actividad agrícola",
    activityRegistered: "Actividad Registrada",
    activityRegisteredDesc: "La actividad ha sido registrada y se está validando con datos satelitales",
    products: "Productos",
    satelliteValidation: "Validación Satelital",
    improvementDetected: "Mejora detectada",
    pending: "Pendiente",
    validatedStatus: "Validada",
    anomalyDetected: "Anomalía Detectada",
    noData: "Sin Datos",
    loadingNotebook: "Cargando cuaderno de campo...",
    errorLoading: "Error al cargar actividades",
    select: "Seleccionar...",
    calendarView: "Calendario de Actividades",
    calendarActivities: "actividades",
    noActivitiesDay: "Sin actividades este día",
    listView: "Lista",
    calendarViewTab: "Calendario",
  },
  vegetation: {
    title: "Análisis Avanzado de Vegetación",
    subtitle: "Índices espectrales Copernicus Sentinel-2 con Meta Índice adaptativo",
    noParcels: "Sin parcelas registradas",
    noParcelsDesc: "Registra una parcela para acceder al análisis avanzado de vegetación.",
    loadingParcels: "Cargando parcelas...",
    selectParcel: "Seleccionar parcela",
    analysis: "Análisis",
    contrastView: "Vista de Contraste",
    indexGuide: "Guía de Índices",
    phenology: "Fenología",
    autoMetaIndex: "Meta Índice Automático",
    autoMetaIndexDesc: "El sistema selecciona automáticamente el índice más relevante según la etapa fenológica de tu cultivo.",
    selectParcelDesc: "Elige una parcela del selector de arriba para ver su análisis de vegetación.",
    dynamicColorScale: "Ajuste Dinámico de Escala de Color",
    dynamicColorScaleDesc: "Ajusta el brillo, contraste y saturación de imágenes satelitales. Elige escalas de color optimizadas para diferentes análisis.",
    howToUse: "Cómo Usar",
    adjustParams: "Ajusta parámetros para optimizar la visualización",
    colorScaleLegend: "Leyenda de Escala de Color",
    usageTips: "Consejos de Uso",
    tip1: "Aumenta el contraste para resaltar diferencias de vegetación",
    tip2: "Usa escala Viridis para visualización accesible",
    tip3: "Auto-stretch optimiza el rango para tu campo específico",
    tip4: "La escala Magma funciona mejor para análisis de quemados",
    coordinates: "Coordenadas",
    whenToUse: "Cuándo usar",
    limitations: "Limitaciones",
    valueInterpretation: "Interpretación de valores",
    low: "Bajo",
    medium: "Medio",
    high: "Alto",
    optimal: "Óptimo",
    recommendedByStage: "Índice Recomendado por Etapa Fenológica",
    recommendedByStageDesc: "Cada etapa del cultivo tiene índices de vegetación más apropiados para el monitoreo",
    quickReference: "Referencia Rápida",
    earlyStages: "Etapas Tempranas (0-30 días)",
    earlyStagesDesc: "Usa <strong>MSAVI</strong> para ignorar el ruido del suelo cuando las plantas son pequeñas.",
    activeGrowth: "Crecimiento Activo (30-75 días)",
    activeGrowthDesc: "<strong>NDVI</strong> es el estándar para evaluar biomasa y vigor durante el crecimiento vegetativo.",
    denseCanopy: "Dosel Denso (75+ días)",
    denseCanopyDesc: "Cambia a <strong>RECI/NDRE</strong> cuando el NDVI se satura. Estos índices detectan variaciones de nitrógeno.",
    entireCycle: "Ciclo Completo",
    entireCycleDesc: "<strong>NDMI</strong> para monitorear contenido de agua en cualquier momento, especialmente útil para planificación de riego.",
    days: "Días",
    noSentinelImages: "No se encontraron imágenes Sentinel-2 válidas para este rango de fechas.",
  }
};
